export default __webpack_public_path__ + "static/media/b5c648ff276a15e7.5a06055d14e0b2b9b4eeb242a6542058.svg";